<template>
  <div id="contenedor-default-usuario">
    <h1>Usuario</h1>
  </div>
</template>

<script>
export default {
  name: 'DefaultUsuario',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
